import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { useNavigate } from 'react-router'
import { languages } from '../../../../../configs/language'
import { Element } from '../../../../common/html/element'
import { selectPath } from '../../../../layout/store/slice'
import {
  COMPONENT_NAME_CAN_GO_TO_LIBRARY,
  COMPONENT_NAME_CAN_GO_TO_LIBRARY_VI,
} from '../../../constant'
import style from './index.module.scss'

export const ButtonBack = ({ text, linkTo, wrapStyle }) => {
  const navigate = useNavigate()

  const locale = useSelector((state) => state.i18n.locale)
  const prevPath = useSelector(selectPath('prevPath'))

  const handleBack = () => {
    if (linkTo) {
      navigate(linkTo)
    } else {
      navigate(-1)
    }
  }
  return (
    <Element
      style={{ border: '1px solid #d5d5d5', ...wrapStyle }}
      className={style.iconBack}
      onClick={handleBack}
    >
      <Element
        elementName="i"
        className="icon-arrow-left"
        style={{ fontSize: 8, color: '#3a414b' }}
      />
      <Element elementName="p">
        {text ? (
          <Translate value={text} />
        ) : (
          `Back to ${getNamePrevComponent(prevPath, locale)}`
        )}
      </Element>
    </Element>
  )
}

export const getNamePrevComponent = (prevPath, locale) => {
  if (locale === languages.vi)
    return COMPONENT_NAME_CAN_GO_TO_LIBRARY_VI[prevPath.split('/').pop()]
  return COMPONENT_NAME_CAN_GO_TO_LIBRARY[prevPath.split('/').pop()]
}

ButtonBack.propTypes = {
  text: PropTypes.string,
  linkTo: PropTypes.string,
  wrapStyle: PropTypes.object,
}

ButtonBack.defaultProps = {
  wrapStyle: {},
}
